import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../utils/config'; // Assuming config file location
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { COLORS, FONTS } from '../../theme/tokens';
import { PANEL_SX } from '../../theme/v2Styles';
// import Layout from '../../components/Layout/Layout'; // Layout is already applied by App.js

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const UnsubscribePage = () => {
  const query = useQuery();
  const email = query.get('email');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const performUnsubscribe = async () => {
      if (!email) {
        setMessage('Email address not provided in the link.');
        setError(true);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(false);
      setMessage('Attempting to unsubscribe...');

      try {
        // Use the POST /api/unsubscribe endpoint
        const response = await axios.post(`${API_URL}/unsubscribe`, { email });

        if (response.data.success) {
          setMessage(response.data.message || 'You have been successfully unsubscribed.');
          setError(false);
        } else {
          setMessage(response.data.message || 'An error occurred during unsubscription.');
          setError(true);
        }
      } catch (err) {
        setMessage(err.response?.data?.message || 'An error occurred. Please try again later.');
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    performUnsubscribe();
  }, [email]); // Re-run effect if email changes (though it shouldn't for a static link)

  return (
    // <Layout> // Removed redundant Layout wrapper
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '60vh', // Adjust height as needed
          textAlign: 'center',
          p: 3,
          bgcolor: COLORS.surfacePanel
        }}
      >
        <Box sx={{ ...PANEL_SX, width: '100%', maxWidth: 560, p: { xs: 3, md: 5 } }}>
          <Typography variant="h3" gutterBottom sx={{ fontFamily: FONTS.heading, fontWeight: 600, fontSize: { xs: '2rem', md: '2.5rem' } }}>
            Unsubscribe from Emails
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            We are updating your email preference.
          </Typography>
          {loading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
              <CircularProgress size={24} sx={{ mr: 1 }} />
              <Typography>{message || 'Processing...'}</Typography>
            </Box>
          ) : (
            <Alert severity={error ? 'error' : 'success'} sx={{ mt: 2, borderRadius: '2px', textAlign: 'left' }}>
              {message}
            </Alert>
          )}
        </Box>
      </Box>
    // </Layout>
  );
};

export default UnsubscribePage;
